import React from 'react';

export function Logo({ size = 'md', showText = true, className = '' }) {
  const sizes = {
    xs: { icon: 'w-6 h-6', text: 'text-sm', crm: 'text-[8px]', iconText: 'text-[10px]' },
    sm: { icon: 'w-7 h-7', text: 'text-base', crm: 'text-[9px]', iconText: 'text-xs' },
    md: { icon: 'w-8 h-8', text: 'text-lg', crm: 'text-[10px]', iconText: 'text-xs' },
    lg: { icon: 'w-10 h-10', text: 'text-xl', crm: 'text-xs', iconText: 'text-sm' },
    xl: { icon: 'w-14 h-14', text: 'text-3xl', crm: 'text-sm', iconText: 'text-lg' },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="logo">
      <div className={`${s.icon} bg-[#0047AB] rounded flex items-center justify-center shrink-0`}>
        <span className={`text-white font-bold font-heading ${s.iconText}`} style={{ letterSpacing: '-0.05em' }}>RL</span>
      </div>
      {showText && (
        <div className="flex flex-col leading-none">
          <span className={`font-heading font-bold text-slate-900 ${s.text} tracking-tight`} style={{ lineHeight: 1.1 }}>Real Leads</span>
          <span className={`font-heading font-semibold text-[#0047AB] ${s.crm} tracking-[0.25em] uppercase`} style={{ lineHeight: 1.4 }}>CRM</span>
        </div>
      )}
    </div>
  );
}

export function LogoWhite({ size = 'md', showText = true, className = '' }) {
  const sizes = {
    xs: { icon: 'w-6 h-6', text: 'text-sm', crm: 'text-[8px]', iconText: 'text-[10px]' },
    sm: { icon: 'w-7 h-7', text: 'text-base', crm: 'text-[9px]', iconText: 'text-xs' },
    md: { icon: 'w-8 h-8', text: 'text-lg', crm: 'text-[10px]', iconText: 'text-xs' },
    lg: { icon: 'w-10 h-10', text: 'text-xl', crm: 'text-xs', iconText: 'text-sm' },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="logo-white">
      <div className={`${s.icon} bg-white/20 rounded flex items-center justify-center shrink-0`}>
        <span className={`text-white font-bold font-heading ${s.iconText}`} style={{ letterSpacing: '-0.05em' }}>RL</span>
      </div>
      {showText && (
        <div className="flex flex-col leading-none">
          <span className={`font-heading font-bold text-white ${s.text} tracking-tight`} style={{ lineHeight: 1.1 }}>Real Leads</span>
          <span className={`font-heading font-semibold text-white/70 ${s.crm} tracking-[0.25em] uppercase`} style={{ lineHeight: 1.4 }}>CRM</span>
        </div>
      )}
    </div>
  );
}
